/** Portal JWT — sessionStorage (탭 단위, 최소 보관) */
const TOKEN_KEY = 'ev123_portal_jwt';
const ACCOUNT_KEY = 'ev123_portal_account';
const ROLE_KEY = 'ev123_portal_role';

export function getPortalToken(): string | null {
  try {
    const t = sessionStorage.getItem(TOKEN_KEY);
    return t && t.trim() ? t.trim() : null;
  } catch {
    return null;
  }
}

export function getPortalAccount(): string | null {
  try {
    const a = sessionStorage.getItem(ACCOUNT_KEY);
    return a && a.trim() ? a.trim() : null;
  } catch {
    return null;
  }
}

/**
 * 캐시된 role 문자열. 서버 신뢰의 단일 출처는 `/api/auth/me` 이며,
 * 이 값은 UI 분기(관리자 메뉴 표시 등) 용도로만 사용한다. 민감 동작은
 * 서버 `require_admin`이 별도 보호한다.
 */
export function getPortalRole(): string | null {
  try {
    const r = sessionStorage.getItem(ROLE_KEY);
    return r && r.trim() ? r.trim() : null;
  } catch {
    return null;
  }
}

export function setPortalRole(role: string | null): void {
  try {
    if (role && role.trim()) sessionStorage.setItem(ROLE_KEY, role.trim());
    else sessionStorage.removeItem(ROLE_KEY);
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent('ev123-auth-changed'));
}

export function setPortalSession(token: string, account: string, role?: string | null): void {
  sessionStorage.setItem(TOKEN_KEY, token);
  sessionStorage.setItem(ACCOUNT_KEY, account);
  if (role !== undefined) {
    if (role && role.trim()) sessionStorage.setItem(ROLE_KEY, role.trim());
    else sessionStorage.removeItem(ROLE_KEY);
  }
  window.dispatchEvent(new CustomEvent('ev123-auth-changed'));
}

export function clearPortalSession(): void {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(ACCOUNT_KEY);
  sessionStorage.removeItem(ROLE_KEY);
  window.dispatchEvent(new CustomEvent('ev123-auth-changed'));
}

export function isPortalLoggedIn(): boolean {
  return !!getPortalToken();
}

export function isPortalAdmin(): boolean {
  return getPortalRole() === 'admin';
}

const LOGIN_NEXT_KEY = 'ev123_login_next';

export function setLoginNext(path: string): void {
  sessionStorage.setItem(LOGIN_NEXT_KEY, path);
}

export function takeLoginNext(): string | null {
  try {
    const p = sessionStorage.getItem(LOGIN_NEXT_KEY);
    sessionStorage.removeItem(LOGIN_NEXT_KEY);
    return p && p.startsWith('/') ? p : null;
  } catch {
    return null;
  }
}
